export default __webpack_public_path__ + "static/media/ASP.de9856cc.png";